import { defineMessages } from 'react-intl';

export default defineMessages({
  add_ons: {
    id: 'account-navbar.add_ons',
    defaultMessage: 'Add-ons'
  },
  reports: {
    id: 'account-navbar.reports',
    defaultMessage: 'Reports',
  },
  global_discount_codes: {
    id: 'account-navbar.global_discount_codes',
    defaultMessage:'Discount Codes'
  },
  myEvents: {
    id: 'account-navbar.myEvents',
    defaultMessage: 'My Events'
  },
  dashboard:{
    id: 'account-navbar.dashboard',
    defaultMessage: 'Dashboard'
  },
  balances:{
    id: 'account-navbar.balances',
    defaultMessage: 'Balances'
  },
  fees: {
    id: 'account-navbar.fees',
    defaultMessage: 'Fees'
  }
})
